import { useState, useEffect, useCallback } from 'react'
import { RequestService } from '../services/RequestService'

const useUserPlan = () => {
  const [loading, setLoading] = useState(true)
  const [data, setData] = useState(null)

  const fetchData = useCallback(async () => {
    setLoading(true)

    try {
      const { data } = await RequestService.getUserPlan()

      setData(data)
    } catch (e) {
      console.log('useUserPlan', e)
    }
    setLoading(false)
  }, [])

  useEffect(() => {
    fetchData()
  }, [])

  return { loading, data, fetchData }
}

export default useUserPlan
